import * as React from "react";

import type { IconProps } from "./types";

export const ExportIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M8.25 1.5H10.5V10.5H8.25V12H10.5C11.325 12 12 11.325 12 10.5V1.5C12 0.675 11.325 0 10.5 0H8.25V1.5Z"
        fill={color}
      />
      <path
        d="M4.1925 3.3075L5.25 2.25L9 6L5.25 9.75L4.1925 8.6925L6.1275 6.75L0 6.75V5.25L6.1275 5.25L4.1925 3.3075Z"
        fill={color}
      />
      <defs>
        <clipPath id="clip0_27858_2340">
          <rect width="12" height="12" fill={color} transform="matrix(0 -1 1 0 0 12)" />
        </clipPath>
      </defs>
    </svg>
  ),
);

export default ExportIcon;
